import selectorReducerFor, { selectorInitialState } from '../redux/selector/reducerFor'
import {
  API_RESOURCE_NAME,
  ApplicationResource,
  CH_RESOURCE_NAME,
  HYBRID_RESOURCE_NAME,
  MANAGED_API_RESOURCE_NAME,
  Resource,
  RTF_RESOURCE_NAME,
  TARGET_RESOURCE_NAME
} from './model'
import { ResourceAction } from './actions'
import fetchReducerFor, { fetchInitialState, FetchState } from '../redux/fetch/reducerFor'
import { ARMApplicationDetail, ARMHybridDetail, ARMServer, Asset, RTFApplication } from '../../remote-api/models'
import { RESOURCE_PREFIX, RESOURCE_RESOURCE_NAME } from './model'
import { FetchAction } from '../redux/fetch/model'
import { ManagedAPI } from '@mulesoft/monitoring-center-components/lib/models/api-manager'

export type ResourceSelectorState = ResourceFetcherState & {
  selected?: Resource
  selectedResources?: Resource[]
}

export type ResourceFetcherState = FetchState<Resource[]> & {
  cloudHub: FetchCHAppsState
  hybrid: FetchHybridAppsState
  rtf: FetchRTFAppsState
  servers: FetchServersState
  apis: FetchAPIsState
  managedApis: FetchManagedAPIsState
}

export type FetchCHAppsState = FetchState<ARMApplicationDetail[]>
export type FetchHybridAppsState = FetchState<ARMHybridDetail[]>
export type FetchRTFAppsState = FetchState<RTFApplication[]>
export type FetchServersState = FetchState<ARMServer[]>
export type FetchAPIsState = FetchState<Asset[]>
export type FetchManagedAPIsState = FetchState<ManagedAPI[]>

export const resourceFetcherInitialState = {
  ...fetchInitialState,
  cloudHub: {...fetchInitialState},
  hybrid: {...fetchInitialState},
  rtf: {...fetchInitialState},
  servers: {...fetchInitialState},
  apis: {...fetchInitialState},
  managedApis: {...fetchInitialState}
}

export const resourceSelectorInitialState = {
  ...selectorInitialState,
  ...resourceFetcherInitialState,
}

export const resourceSelectorReducer = (origin?: string) => {
  const resourceReducerForOrigin = selectorReducerFor<Resource>(RESOURCE_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  const cloudHubReducerForOrigin = fetchCHAppsReducer(origin)
  const hybridReducerForOrigin = fetchHybridAppsReducer(origin)
  const rtfReducerForOrigin = fetchRTFAppsReducer(origin)
  const serversReducerForOrigin = fetchServersReducer(origin)
  const apisReducerForOrigin = fetchAPIsReducer(origin)
  const managedAPIsReducerForOrigin = fetchManagedAPIsReducer(origin)

  return function reducer(state: ResourceSelectorState = resourceSelectorInitialState, action: ResourceAction): ResourceSelectorState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action),
      cloudHub: cloudHubReducerForOrigin(state.cloudHub, action),
      hybrid: hybridReducerForOrigin(state.hybrid, action),
      rtf: rtfReducerForOrigin(state.rtf, action),
      servers: serversReducerForOrigin(state.servers, action),
      apis: apisReducerForOrigin(state.apis, action),
      managedApis: managedAPIsReducerForOrigin(state.managedApis, action)
    }
  }
}

export const resourceFetcherReducer = (origin?: string) => {
  const cloudHubReducerForOrigin = fetchCHAppsReducer(origin)
  const hybridReducerForOrigin = fetchHybridAppsReducer(origin)
  const rtfReducerForOrigin = fetchRTFAppsReducer(origin)
  const serversReducerForOrigin = fetchServersReducer(origin)
  const apisReducerForOrigin = fetchAPIsReducer(origin)
  const managedAPIsReducerForOrigin = fetchManagedAPIsReducer(origin)

  return function reducer(state: ResourceFetcherState = resourceFetcherInitialState, action: ResourceAction): ResourceFetcherState {
    return {
      ...state,
      cloudHub: cloudHubReducerForOrigin(state.cloudHub, action),
      hybrid: hybridReducerForOrigin(state.hybrid, action),
      rtf: rtfReducerForOrigin(state.rtf, action),
      servers: serversReducerForOrigin(state.servers, action),
      apis: apisReducerForOrigin(state.apis, action),
      managedApis: managedAPIsReducerForOrigin(state.managedApis, action)
    }
  }
}

export const fetchCHAppsReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<ARMApplicationDetail[]>(CH_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchCHAppsState = {...fetchInitialState}, action: FetchAction<ApplicationResource>): FetchCHAppsState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}

export const fetchHybridAppsReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<ARMHybridDetail[]>(HYBRID_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchHybridAppsState = {...fetchInitialState}, action: FetchAction<ARMHybridDetail>): FetchHybridAppsState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}

export const fetchRTFAppsReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<RTFApplication[]>(RTF_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchRTFAppsState = {...fetchInitialState}, action: FetchAction<RTFApplication>): FetchRTFAppsState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}

export const fetchServersReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<ARMServer[]>(TARGET_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchServersState = {...fetchInitialState}, action: FetchAction<ARMServer>): FetchServersState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}

export const fetchAPIsReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<Asset[]>(API_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchAPIsState = {...fetchInitialState}, action: FetchAction<Asset>): FetchAPIsState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}

export const fetchManagedAPIsReducer = (origin?: string) => {
  const resourceReducerForOrigin = fetchReducerFor<ManagedAPI[]>(MANAGED_API_RESOURCE_NAME, RESOURCE_PREFIX, origin)
  return function reducer(state: FetchManagedAPIsState = {...fetchInitialState}, action: FetchAction<ManagedAPI>): FetchManagedAPIsState {
    return {
      ...state,
      ...resourceReducerForOrigin(state, action)
    }
  }
}
